import { render, staticRenderFns } from "./GroupMembersPage.vue?vue&type=template&id=645c7bdd&"
import script from "./GroupMembersPage.vue?vue&type=script&lang=js&"
export * from "./GroupMembersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports